var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-center align-center"},[_vm._t("default",[_c('img',{attrs:{"src":_vm.src,"alt":_vm.alt,"width":"35%","height":"35%"}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }